import {API_URL} from "./index";

// Public : sert à n'afficher le lien d'accueil que s'il y a une campagne principale en ligne.
// Ne rejette jamais : en cas de doute, le lien reste masqué.
export async function apiGetMainCampaign() {
    try {
        const res = await fetch(`${API_URL}/campagnes/principale`);
        if (!res.ok) return {active: false};
        return await res.json();
    } catch {
        return {active: false};
    }
}
